import { decodeToken, isExpired } from "react-jwt";

import { getAccessToken } from "./index";

// Constants
// eslint-disable-next-line no-underscore-dangle
const SESSION_TIMEOUT = window.__RUNTIME_CONFIG__?.SESSION_TIMEOUT || 15; // Default to 15 minutes
// eslint-disable-next-line no-underscore-dangle
const isMSEntraLogin = window.__RUNTIME_CONFIG__?.IDENTITY_SERVICE === "entra";

const MAX_TOKEN_AGE_MS = SESSION_TIMEOUT * 60 * 1000; // SESSION_TIMEOUT in milliseconds - time that user can stay inactive in application
// This adjustment accounts for the 5-minute discrepancy in Azure AD token timestamps ("Clock skew" in Azure)
const AZURE_TOKEN_OFFSET = 5 * 60 * 1000; // 5 minutes offset

/**
 * Checks if the user session is still active based on token age and expiration.
 * @returns {boolean} `true` if the session is still active, otherwise `false`.
 */
export const isUserSessionActive = (): boolean => {
    const token = getAccessToken();
    if (!token || isExpired(token)) {
        return false;
    }

    const decoded = decodeToken<{ iat: number }>(token);
    if (!decoded?.iat) {
        return false;
    }

    const tokenIssuedAt = decoded.iat * 1000; // Convert `iat` from seconds to ms
    const currentTime = Date.now();
    const tokenAge = currentTime - tokenIssuedAt; // Age in milliseconds

    const allowedTokenAge = isMSEntraLogin ? MAX_TOKEN_AGE_MS + AZURE_TOKEN_OFFSET : MAX_TOKEN_AGE_MS;
    return tokenAge <= allowedTokenAge;
};
